import { render, staticRenderFns } from "./FaqCreateDialog.vue?vue&type=template&id=776c3a27&"
import script from "./FaqCreateDialog.vue?vue&type=script&lang=js&"
export * from "./FaqCreateDialog.vue?vue&type=script&lang=js&"
import style0 from "./FaqCreateDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports